// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "nav[data-v-11865edd]{padding:10px 10px 0;margin:0 0 15px;display:flex;border-bottom:1px solid #fff;font-size:14px}nav div[data-v-11865edd]{cursor:pointer;padding:10px 20px;border-left:1px solid #fff;border-top:1px solid #fff;opacity:.8;background:#89B784}nav div.active[data-v-11865edd]{opacity:1}nav div[data-v-11865edd]:nth-child(1){border-top-left-radius:5px}nav div[data-v-11865edd]:nth-last-child(1){border-top-right-radius:5px;border-right:1px solid #fff}\n", ""]);
// Exports
module.exports = exports;
